export class GetSection {
	static readonly type = '[Sections] Get';
	constructor(public readonly name: string, public readonly type: string) {}
}

export class GetSectionSuccess {
	static readonly type = '[Section] Get Section Success';
	constructor(public readonly section: any) {}
}
